// Copyright (c) 2016 Deere & Company

import KeyValuePair from './key-value-pair';
import t from 'tcomb';

const PartReturnQuestion = t.struct({
    answer: t.String,
    id: t.String,
    isMandatory: t.Boolean,
    options: t.maybe(t.list(KeyValuePair)),
    question: t.String,
    type: t.String
}, {
    name: 'PartReturnQuestion',
    strict: true
});

export const getDefaultState = () => new PartReturnQuestion({
    answer: '',
    id: '',
    isMandatory: false,
    options: [],
    question: '',
    type: 'S'
});

export default PartReturnQuestion;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/part-return-question.js